<template>
  <div>테스트화면 SLO</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {

        }
    },
    mounted() {
        this.initSlo();
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        initSlo() {
            let obj = this;
            // let reqData = {
            //     url: "/api/auth/slo/circleSlo",
            //     method: "post",
            //     params: {
            //     }
            // };
            // obj
            // .COWORK_REST_SIMPLE_ACTION(reqData)
            // .then(function(res) {
            //     console.log("###########");
            //     console.log(res);
            //     console.log("###########");
            // })
            // .catch(function(err) {
            //     console.log(err);
            // })
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/slo/CircleSlo.vue